import { Link, NavLink } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "./ui/button";
import { restaurantInfo } from "../mock";

export const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/menu", label: "Menu" },
  { to: "/gallery", label: "Gallery" },
  { to: "/reservations", label: "Reservations" },
  { to: "/contact", label: "Contact" }
];


export function NavLogo() {
  return (
    <Link to="/" className="flex items-center gap-3">
      {/* Logo Image */}
      <img
        src="/image/logo/logo spice.png"
        alt="Sea Spice Kitchen"
        className="w-12 h-12 object-contain"
      />

      <div className="leading-tight">
        <h1 className="text-white text-xl md:text-2xl font-bold">
          Sea Spice Kitchen
        </h1>

        <div className="text-spice-gold text-[10px] md:text-xs tracking-[0.3em] uppercase">
          Coastal Fusion · Frankston
        </div>
      </div>
    </Link>
  );
}
export function DesktopNav() {
  return (
    <nav className="hidden lg:flex items-center gap-1">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          className={({ isActive }) =>
            `relative px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-300 ${
              isActive ? "text-spice-gold" : "text-white/85 hover:text-spice-gold"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {item.label}
              <span
                className={`absolute left-1/2 -translate-x-1/2 bottom-1 h-px bg-spice-gold transition-all duration-300 ${
                  isActive ? "w-6" : "w-0"
                }`}
              />
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

export function DesktopCTA() {
  return (
    <div className="hidden lg:flex items-center gap-4">
      <a
        href={`tel:${restaurantInfo.phone}`}
        className="flex items-center gap-2 text-white/85 hover:text-spice-gold text-sm transition-colors"
      >
        <Phone size={14} />
        {restaurantInfo.phoneDisplay}
      </a>
      <Link to="/reservations">
        <Button className="bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold tracking-wide rounded-none px-6 h-11">
          Book a Table
        </Button>
      </Link>
    </div>
  );
}

export function MobileMenu({ open }) {
  return (
    <div
      className={`lg:hidden bg-[#0d2929] overflow-hidden transition-all duration-500 ${
        open ? "max-h-[600px] border-t border-white/10" : "max-h-0"
      }`}
    >
      <nav className="flex flex-col px-6 py-6 gap-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `py-3 px-3 text-base font-medium border-b border-white/5 ${
                isActive ? "text-spice-gold" : "text-white/85"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
        <Link to="/reservations" className="mt-4">
          <Button className="w-full bg-spice-gold hover:bg-[hsl(38_75%_46%)] text-[#0d2929] font-semibold rounded-none h-12">
            Book a Table
          </Button>
        </Link>
        <a
          href={`tel:${restaurantInfo.phone}`}
          className="mt-3 flex items-center justify-center gap-2 text-white/85 text-sm"
        >
          <Phone size={14} />
          {restaurantInfo.phoneDisplay}
        </a>
      </nav>
    </div>
  );
}
